import { render, staticRenderFns } from "./DeliverySharedResource.vue?vue&type=template&id=0a3f4c13&scoped=true&"
import script from "./DeliverySharedResource.vue?vue&type=script&lang=js&"
export * from "./DeliverySharedResource.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySharedResource.vue?vue&type=style&index=0&id=0a3f4c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f4c13",
  null
  
)

export default component.exports